import { useRef } from "react";
import { useFrame } from "@react-three/fiber";
import * as THREE from "three";
import { HERO_COLORS } from "./constants";

/**
 * Holographic orbit rings — three tilted circles rotating at different speeds
 * with tiny "satellite" spheres travelling along them. Purple / pink only.
 */
export default function OrbitRings() {
  return (
    <group>
      <Ring radius={1.55} tilt={[Math.PI / 3.2, 0, Math.PI / 8]}  speed={0.10} color={HERO_COLORS.purple} sat={HERO_COLORS.pinkLight} />
      <Ring radius={1.85} tilt={[Math.PI / 2.4, Math.PI / 12, 0]} speed={-0.06} color={HERO_COLORS.violet}  sat={HERO_COLORS.purple}    />
      <Ring radius={2.2}  tilt={[Math.PI / 6, -Math.PI / 8, 0]}   speed={0.04}  color={HERO_COLORS.pink}    sat={HERO_COLORS.glow}      />
    </group>
  );
}

function Ring({ radius, tilt, speed, color, sat }) {
  const groupRef = useRef();
  const satRef   = useRef();

  useFrame((_, delta) => {
    if (groupRef.current) groupRef.current.rotation.z += delta * speed;
    if (satRef.current) {
      const t = performance.now() * 0.001 * speed * 6;
      satRef.current.position.set(
        Math.cos(t) * radius,
        Math.sin(t) * radius,
        0,
      );
    }
  });

  /* Circle geometry — thin torus for crisp lines. */
  return (
    <group rotation={tilt} ref={groupRef}>
      <mesh>
        <torusGeometry args={[radius, 0.004, 8, 128]} />
        <meshBasicMaterial
          color={color}
          transparent
          opacity={0.55}
          blending={THREE.AdditiveBlending}
          depthWrite={false}
          toneMapped={false}
        />
      </mesh>
      <mesh ref={satRef}>
        <sphereGeometry args={[0.02, 16, 16]} />
        <meshBasicMaterial
          color={sat}
          toneMapped={false}
          blending={THREE.AdditiveBlending}
          depthWrite={false}
        />
      </mesh>
    </group>
  );
}
